/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

/**
 *
 * @class DiversionInlineEdit
 *
 * @brief basic interface for working with edits to single columns; allows us to publish
 * edits from one view of the diversions to the other views, i.e. from the input edit pane
 * to any of the summary views
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionInlineEdit {

  /** the workblock being modified */
  public id: number;

  /** the filed being modified */
  public field: string;

  /** the new value */
  public value: any;

  /** standard constructor, allow anonymous object initialization */
  public constructor(init?: Partial<DiversionInlineEdit>) {

    Object.assign(this, init);
  }

}
